import { render } from "./insurance_invoices_detail.vue?vue&type=template&id=d877b8dc&scoped=true"
import script from "./insurance_invoices_detail.vue?vue&type=script&lang=js"
export * from "./insurance_invoices_detail.vue?vue&type=script&lang=js"

import "./insurance_invoices_detail.vue?vue&type=style&index=0&id=d877b8dc&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d877b8dc"]])

export default __exports__